import { Flex, Typography, Button } from 'components';
import { ReactElement } from 'react';
import styled from 'styled-components';
import AuthenticatorAppSvg from 'app/images/authenticatorapp.svg';

interface AuthenticatorInstallProps {
  onClick: () => void;
}
const AuthenticatorApp = styled.img`
  margin-top: 10px;
`;

const AuthenticatorInstall = ({ onClick }: AuthenticatorInstallProps): ReactElement => {
  return (
    <Flex
      alignSelf="center"
      flexDirection="column"
      padding={24}
      alignItems="center"
      justifyContent="space-between"
      maxWidth={600}
      backgroundColor="white"
    >
      <Flex justifyContent="center">
        <Flex marginBottom={16} justifyContent="center">
          <Typography fontWeight="bold" color="dark_350" textAlign="center">
            Instale o aplicativo autenticador
          </Typography>
        </Flex>

        <Flex maxWidth={500}>
          <Flex marginBottom={16} justifyContent="center">
            <Typography type="type1" color="dark_350" textAlign="center">
              Para configurar a autenticação em dois fatores via aplicativo, baixe e instale gratuitamente um aplicativo autenticador em seu celular.
            </Typography>
          </Flex>

          <Flex marginBottom={16} justifyContent="center">
            <Typography type="type1" color="dark_350" textAlign="center">
              Alguns exemplos são o Google Authenticator ou Microsoft Authenticator, disponíveis no Google Play ou Apple Store.
            </Typography>
          </Flex>
        </Flex>

        <Flex alignSelf="flex-start">
          <Typography type="type1" fontWeight="bold" color="dark_350">
            Exemplo
          </Typography>

          <AuthenticatorApp src={AuthenticatorAppSvg} width="100%" alt="" />
        </Flex>

        {/** 
       * TODO FAZER QUANDO A WIKI ESTIVER PRONTA
        <Flex marginY={32}>
          <Link to={``}>
            <Typography fontWeight="bold" type="type1" color="primary_400">
              Dúvidas sobre a autenticação em dois fatores? Acesse o FAQ
            </Typography>
          </Link>
        </Flex>
     
  */}
      </Flex>
      <Flex marginTop={32}>
        <Button type="button" p={24} bg="primary_400" color="white" colorHover="white" size="small" onClick={onClick}>
          Continuar
        </Button>
      </Flex>
    </Flex>
  );
};

export default AuthenticatorInstall;
